import { useState, useEffect } from "react";
import { GenerateFormattedDate } from "../../Components/Utils/Date/GenerateFormattedDate";
import { useGetDeviceSettingLogsforReportMutation } from "../../store/storageRoles/devicesSharedApi";
import { useGetDealerRolesDeviceSettingLogsforReportMutation } from "../../store/dealerRoles/devicesApi";
import useAuth from "../useAuth";

export const useDeviceSettingReportData = (id, token) => {
  const { auth } = useAuth();
  const isDealer = auth?.role === "dealer";
  const [info, setInfo] = useState(false);
  const [input, setInput] = useState({
    id: id,
    token: token,
    type: "UpdateSetting",
    createdInfo: "",
    createdInfoSecond: "",
    productName: "",
  });
  const [filterType, setFilterType] = useState("Day");
  const [date, setDate] = useState(new Date());
  const [dateSecond, setDateSecond] = useState(new Date());
  const [paginationNumber, setPaginationNumber] = useState(1);
  const [
    getStorageDeviceSettingLogsforReport,
    {
      data: storageSettingData,
      isFetching: isStorageSettingFetching,
      isLoading: isStorageSettingLoading,
      isError: isStorageSettingError,
      error: storageSettingError,
    },
  ] = useGetDeviceSettingLogsforReportMutation();
  const [
    getDealerDeviceSettingLogsforReport,
    {
      data: dealerSettingData,
      isFetching: isDealerSettingFetching,
      isLoading: isDealerSettingLoading,
      isError: isDealerSettingError,
      error: dealerSettingError,
    },
  ] = useGetDealerRolesDeviceSettingLogsforReportMutation();

  const getDeviceSettingLogsforReport = isDealer
    ? getDealerDeviceSettingLogsforReport
    : getStorageDeviceSettingLogsforReport;
  const settingData = isDealer ? dealerSettingData : storageSettingData;
  const isSettingFetching = isDealer ? isDealerSettingFetching : isStorageSettingFetching;
  const isSettingLoading = isDealer ? isDealerSettingLoading : isStorageSettingLoading;
  const isSettingError = isDealer ? isDealerSettingError : isStorageSettingError;
  const settingError = isDealer ? dealerSettingError : storageSettingError;

  const [Datas, setDatas] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    // Setting data işleme
    if (settingData?.data) {
      setDatas(
        settingData.data.filter((item) => item.logs && item.logs.length > 0) ||
          []
      );
    }
  }, [settingData]);

  useEffect(() => {
    setInput((prev) => ({ ...prev, createdInfo: GenerateFormattedDate(date) }));
  }, [date]);

  useEffect(() => {
    setInput((prev) => ({
      ...prev,
      createdInfoSecond: GenerateFormattedDate(dateSecond),
    }));
  }, [dateSecond]);

  const handleFilterType = (type) => {
    setFilterType(type);
  };

  const handleGetLogData = (productName = "") => {
    if (input.createdInfo && input.createdInfoSecond && input.id) {
      const requestData = {
        id: input.id,
        createdInfo: input.createdInfo,
        createdInfoSecond: input.createdInfoSecond,
        productName: productName || input.productName,
        token: input.token,
      };

      // Önce mevcut verileri temizle
      setDatas([]);

      // Setting raporu için endpoint çağır
      getDeviceSettingLogsforReport(requestData);
    }
  };

  return {
    info,
    setInfo,
    input,
    setInput,
    filterType,
    handleFilterType,
    date,
    setDate,
    dateSecond,
    setDateSecond,
    paginationNumber,
    setPaginationNumber,
    isFetching: isSettingFetching,
    isLoading: isSettingLoading,
    isError: isSettingError,
    error: settingError,
    Datas,
    selectedDate,
    setSelectedDate,
    handleGetLogData,
  };
};
